<template>
  <div class="tinymce-container editor-container" :class="{fullscreen:fullscreen}">
    <textarea class="tinymce-textarea" :id="tinymceId"></textarea>
    <div class="editor-custom-btn-container">
      <editorImage color="#20a0ff" class="editor-upload-btn" @successCBK="imageSuccessCBK"></editorImage>
    </div>
  </div>
</template>

<script>
import editorImage from './components/editorImage'
// import 'tinymce/themes/modern/theme'
// import 'tinymce/plugins/image'
// import 'tinymce/plugins/link'

export default {
  name: 'tinymce',
  components: { editorImage },
  props: {
    id: {
      type: String,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    toolbar: {
      type: Array,
      required: false,
      default() {
        // outdent indent subscript superscript
        return [
          'bold italic underline strikethrough alignleft aligncenter alignright fontsizeselect blockquote undo redo removeformat code codesample',
          'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime table emoticons forecolor backcolor fullscreen',
        ]
        // return ['removeformat undo redo |  bold italic blockquote | alignleft aligncenter alignright | outdent indent | fontsizeselect forecolor backcolor | fullscreen code | link unlink'] // image
      },
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table',
    },
    height: {
      type: Number,
      required: false,
      default: 360,
    },
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id || 'vue-tinymce-' + +new Date(),
      fullscreen: false,
    }
  },
  watch: {
    value(val) {
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() => window.tinymce.get(this.tinymceId).setContent(val))
      }
    },
  },
  mounted() {
    const _this = this
    console.log('window',window)
    window.tinymce.init({
      // language_url: '/static/tinymce/zh_CN.js',
      language: 'zh_CN',
      fontsize_formats:
        '10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px',
      selector: `#${this.tinymceId}`,
      height: this.height,
      body_class: 'panel-body ',
      object_resizing: false,
      toolbar: this.toolbar,
      menubar: this.menubar,
      plugins: [
        'advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools importcss insertdatetime link lists nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount',
      ],
      // plugins: 'advlist, autolink, code, paste, textcolor, colorpicker, fullscreen, image, link, lists, media, wordcount, imagetools',
      end_container_on_empty_block: true,
      powerpaste_word_import: 'clean',
      code_dialog_height: 450,
      code_dialog_width: 1000,
      advlist_bullet_styles: 'square',
      advlist_number_styles: 'default',
      block_formats: '普通标签=p;小标题=h2;',
      imagetools_cors_hosts: ['wpimg.wallstcn.com', 'wallstreetcn.com'],
      imagetools_toolbar: 'watermark',
      default_link_target: '_self',
      target_list: false,
      link_title: false,
      init_instance_callback: (editor) => {
        if (_this.value) {
          editor.setContent(_this.value)
        }
        _this.hasInit = true
        editor.on('NodeChange Change KeyUp', () => {
          this.hasChange = true
          this.$emit('input', editor.getContent({ format: 'raw' }))
        })
        editor.on('blur', () => {
          this.hasChange = false
        })
      },
      setup(editor) {
        editor.on('FullscreenStateChanged', (e) => {
          _this.fullscreen = e.state
        })
      },
      audio_template_callback: function (data) {
        console.log('data:音频 ', data);
        
      },
      video_template_callback: function (data) {
        console.log('data1111: ', data);
        data.width = '1200px'
        data.height = 'auto'
        return `<p style="width:100%;height:auto;display:block;margin:0 auto;"><span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen"  data-mce-p-frameborder="no" data-mce-p-scrolling="no"  data-mce-p-src=${data.source1} data-mce-p-width=${data.width} data-mce-p-height=${data.height}  data-mce-p-controls="controls" data-mce-html="%20" style="margin:0 auto;display:block"><video class="myTinyVideo" width=${data.width} height=${data.height} controls="controls" style="margin:0 auto !important"><source src=${data.source1} type=${data.source1mime}></source></video></span></p>`
      },
    })
  },
  methods: {
    imageSuccessCBK(arr) {
      const _this = this
      console.log(arr, 'arr')
      arr.forEach((v) => {
        window.tinymce
          .get(_this.tinymceId)
          .insertContent(
            `<img class="wscnph" width="` +
              v.width / 4 +
              `px" src="${v.url.fileUrl}" >`
          )
        // `<p><span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" </span></p>`
        console.log(v, 'v')
      })
    },
  },
  destroyed() {
    window.tinymce.get(this.tinymceId).destroy()
  },
}
</script>

<style scoped lang="less">
.tinymce-container {
  position: relative;
}
.tinymce-container  .mce-fullscreen {
  z-index: 10000;
}
.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 0px;
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}
.editor-upload-btn {
  display: inline-block;
}
</style>
